import script from "./PopUp.vue?vue&type=script&setup=true&lang=js"
export * from "./PopUp.vue?vue&type=script&setup=true&lang=js"

import "./PopUp.vue?vue&type=style&index=0&id=3b9b1990&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b9b1990"]])

export default __exports__